<template>
  <StudioMultiSelect
    v-model="selectedOption"
    :items="options"
    :label="label"
    :placeholder="placeholder"
    @clearClick="$emit('clearInfo', label)"
  >
    <template v-slot:selection="{item, index}">
      <span
        v-if="index === 0 && selectedOption.length === options.length"
        class="lovers-haters-filter__placeholder"
      >
        {{ placeholder }}
      </span>
      <template
        v-else-if="selectedOption.length !== options.length"
      >
        <v-chip
          v-if="index < minimumFilterView"
          small
        >
          <span>{{ item }}</span>
        </v-chip>
        <span
          v-if="index === minimumFilterView"
          class="grey--text caption"
        >
          (+{{ selectedOption.length - minimumFilterView }} {{ message }})
        </span>
      </template>
    </template>
  </StudioMultiSelect>
</template>

<script>
import StudioMultiSelect from '@/components/filter/models/StudioMultiSelect';

export default {
  name: 'LoversAndHatersFilter',
  components: {
    StudioMultiSelect,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    label: {
      type: String,
      default: 'Classificação de usuário',
    },
    placeholder: {
      type: String,
      default: 'Todos',
    },
  },
  data() {
    return {
      options: ['Lovers', 'Haters'],
      minimumFilterView: 1,
    };
  },
  computed: {
    message() {
      return this.selectedOption.length - this.minimumFilterView === 1 ? 'outro' : 'outros';
    },
    selectedOption: {
      get() {
        if (!this.value) {
          return [...this.options];
        }

        const value = this.value && this.value.value;

        if (value && value.length === 0) {
          return [];
        }

        return value;
      },
      set(newValue) {
        if (newValue && newValue.length === 0) {
          return this.$emit('input', {
            value: [],
          });
        }

        if (newValue.length === this.options.length) {
          return this.$emit('input', undefined);
        }

        this.$emit('input', {
          value: newValue.map(v => v),
        });
      },
    },
  },
};
</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }

  .lovers-haters-filter__placeholder {
    font-size: 14px;
    color: #919191;
  }

  ::v-deep {
    input {
      font-size: 14px;
    }
  }
</style>
